import { Flex, Text, VStack } from '@chakra-ui/react'

const Stability = () => {
  return (
    <Flex
      w="100%"
      justifyContent="center"
      alignItems="flex-end"
      position="relative"
      h="100%"
    >
      <VStack
        top={{
          base: '14%',
          sm: '9%',
          md: '12%',
          lg: '15%',
          xl: '15%'
        }}
        left="32%"
        position="absolute"
        alignItems="flex-start"
      >
        <Text
          fontWeight={700}
          fontSize={{
            base: '12px',
            sm: '14px',
            md: '22px',
            xl: '28px',
            '2xl': '32px'
          }}
          lineHeight={1.1}
          textTransform="uppercase"
          textAlign="left"
          w={{
            base: '120px',
            sm: '140px',
            md: '220px',
            xl: '320px',
            '2xl': '360px'
          }}
          mt={{
            base: 0,
            sm: 5
          }}
        >
          NON-SLIP SUCTION GRIP BASE
        </Text>
      </VStack>
      <VStack
        w="100%"
        h="100%"
        alignItems="center"
        justifyContent="flex-end"
        zIndex={10}
      >
        <Text
          textTransform="uppercase"
          textAlign="left"
          textStyle="gripProblemTitle"
          w={{
            base: '90%',
            sm: '400px',
            md: '500px',
            lg: '800px',
            xl: '900px'
          }}
          mt={5}
        >
          STABILITY REDEFINED
        </Text>
        <Text
          textAlign="left"
          textStyle="gripContentSmall"
          mb={{
            base: '8px',
            sm: '20px',
            md: '40px',
            xl: '80px',
            '2xl': '120px'
          }}
          w={{
            base: '90%',
            sm: '400px',
            md: '500px',
            lg: '800px',
            xl: '900px'
          }}
          fontWeight={1}
        >
          With a non-slip suction grip base, the Arctic Grip Tumbler defies
          gravity. Say goodbye to accidental spills and hello to a stable and
          secure drink experience. It's the perfect choice for both your desk
          and your outdoor adventures.
        </Text>
      </VStack>
    </Flex>
  )
}

export default Stability
